import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteContentContext = createContext({ content: {}, c: (k, f) => f });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState({});

  useEffect(() => {
    axios.get(`${API}/content`).then(r => setContent(r.data)).catch(() => {});
  }, []);

  const c = useCallback((key, fallback = '') => content[key] || fallback, [content]);

  return <SiteContentContext.Provider value={{ content, c }}>{children}</SiteContentContext.Provider>;
}

export const useSiteContent = () => useContext(SiteContentContext);
